import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';

export const StyledStack = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'borderTop'
})(({ theme, borderTop }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.vpColors.white,
  borderBottom: `1px solid ${theme.palette.vpColors.greyLight}`,
  height: theme.vpValues.appBarHeight,
  flexShrink: 0,
  padding: '0px 36px',
  ...(borderTop && {
    borderTop: `1px solid ${theme.palette.vpColors.greyLight}`
  }),
  [theme.breakpoints.down('md')]: {
    height: 'auto',
    flexDirection: 'column',
    alignItems: 'center'
  }
}));



// WEBPACK FOOTER //
// ./src/vp-ui/layout/VpAppBar/styles.js